import * as React from 'react';
import styled from 'styled-components';
import Benefits from '../Benefits';
import { useTabsState } from './TabsContext';
import ActionButton from '@ids/components/ActionButton/ActionButton';
import { useIdsGaTracking, useQuestionnaireFlow } from '@ids/hooks';
import CTAPush from '@ids/components/CTAPush';
import { useFeatureToggle } from '@ids/appshell/hooks';
import { SerializedPriceTier } from '@ids/types/now-api';

const StyledTabPanels = styled.div`
    display: flex;
    justify-content: center;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.white};
    padding: 20px;
`;

const StyledTabPanel = styled.div`
    &[data-selected='false'] {
        visibility: hidden;
        margin-right: -100%;
        width: 100%;
        min-width: 100%;
    }
`;

const StyledCTAButton = styled(ActionButton)`
    height: 52px;
    transition: none;
`;

const TabPanels = () => {
    const tabs = useTabsState();
    const { startQuestionnaire } = useQuestionnaireFlow();
    const { trackIdsEvent } = useIdsGaTracking();
    const { p100StudioCTAPush } = useFeatureToggle();

    const onClick = (priceTier: SerializedPriceTier) => () => {
        trackIdsEvent({ action: 'Price Tiers', label: priceTier.trackingLabel });
        startQuestionnaire({
            surveySparrowConfig: priceTier.surveySparrowConfig,
            sku: priceTier.sku,
        });
    };

    return (
        <StyledTabPanels>
            {tabs.map((tab, idx) => {
                return (
                    <StyledTabPanel
                        data-selected={tab.isSelected}
                        key={tab.title}
                        role="tabpanel"
                        aria-labelledby={`tab-${idx}`}
                    >
                        <StyledCTAButton onClick={onClick(tab)} data-testid={`tab-cta-price-${idx + 1}-button`}>
                            {tab.ctaText}
                        </StyledCTAButton>
                        {p100StudioCTAPush && tab.ctaPush && (
                            <CTAPush {...tab.ctaPush} color="#5F8B80" shouldAnimate={false} />
                        )}
                        <Benefits benefits={tab.benefits} />
                    </StyledTabPanel>
                );
            })}
        </StyledTabPanels>
    );
};

export default TabPanels;
